export const COOKIE_CONSENT_NAME = 'cookieconsent';
